export default __webpack_public_path__ + "static/media/Vector6.cc3fda23.svg";